// mui
import Box from '@mui/material/Box';

// icons
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

// types
interface TopicCardCommentCountProps {
    count: number;
}

export default function TopicCardCommentCount(props: TopicCardCommentCountProps) {
    const { count } = props;

    return (
        <Box
            sx={{
                display: "inline-flex",
                alignItems: "center",
                p: 1,
                mr: "auto",
                bgcolor: (theme) => theme.palette.grey[200],
                borderRadius: 2,
                '& .MuiSvgIcon-root': { color: (theme) => theme.palette.grey[600] },
                '& span.label': { ml: 1, fontSize: 12 },
                '& span.num': {
                    px: 1,
                    py: 0.5,
                    ml: 1,
                    fontSize: 12,
                    lineHeight: 1,
                    color: (theme) => theme.palette.common.white,
                    bgcolor: (theme) => theme.palette.grey[600],
                    borderRadius: 1,
                },
            }}
            aria-label="comment"
        >
            <ChatBubbleIcon fontSize="small" />
            <span className="label">コメント</span>
            <span className="num">{count}</span>
        </Box>
    );
}